import { FC } from 'react';
import ModalAtom from 'components/atoms/ModalAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import DangerPrimaryButton from 'components/atoms/Button/DangerPrimaryButton';
import './styles.scss';

interface Props {
  title: string;
  description: string;
  cancelButtonText: string;
  acceptButtonText: string;
  onCancel: () => void;
  onAccept: () => void;
  isVisible: boolean;
  isLoading: boolean;
}

const RevokeExternalInvitationModal: FC<Props> = ({
  title,
  description,
  cancelButtonText,
  acceptButtonText,
  onCancel,
  onAccept,
  isVisible,
  isLoading,
}) => {
  return (
    <ModalAtom
      className={'RevokeExternalInvitationModal'}
      title={title}
      onCancel={onCancel}
      open={isVisible}
      destroyOnClose
      footer={[
        <DefaultButton
          disabled={isLoading}
          onClick={onCancel}
          title={cancelButtonText}
          key={cancelButtonText}
        />,
        <DangerPrimaryButton
          loading={isLoading}
          onClick={onAccept}
          title={acceptButtonText}
          key={acceptButtonText}
        />,
      ]}
    >
      {description}
    </ModalAtom>
  );
};

export default RevokeExternalInvitationModal;
